import React, { useCallback, useEffect, useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import {
  isAndroid,
  isChrome,
  isDesktop,
  isFirefox,
  isIOS,
  isOpera,
  isSafari,
} from "react-device-detect";
import { useTranslation } from "next-i18next";

import {
  CUSTOM_EVENT_TYPE_STASH_INSTALL_PROMPT,
  WINDOW_KEY_INSTALL_EVENT,
} from "@/shared/utils/sw/sw.constants";
import IconView from "@/shared/components/IconView/IconView";
import EgwWebFont from "../../../assets/EgwWebFont";
import { Button } from "@/components/index";
import useDialogInstallInstructions from "@/components/Button/DialogInstallInstructions";
import { useIsStandAloneInstalled, useIsStandAlone } from "@/shared/hooks/pwa/pwa";
import { LANDING_SELECTORS } from "@/utils/landing/landing.constants";

const ButtonInstallPWA = ({ className, isRenderAsText = false, variant, color, size }) => {
  const { t } = useTranslation();
  const [isShown, SetIsShown] = useState(false);
  const [isCanPrompt, setIsCanPrompt] = useState(true);
  const openDialogInstallInstructions = useDialogInstallInstructions();
  const isCanShowInstallInstructions =
    ((isAndroid || isDesktop) && isChrome) ||
    (isIOS && isSafari) ||
    (isAndroid && isFirefox) ||
    (isAndroid && isOpera);
  const isStandAlone = useIsStandAlone();
  const isPWAInstalled = useIsStandAloneInstalled();

  const handleClick = useCallback(() => {
    if (isCanPrompt) {
      global.window[WINDOW_KEY_INSTALL_EVENT].prompt();
    } else if (isCanShowInstallInstructions) {
      openDialogInstallInstructions();
    }
  }, [openDialogInstallInstructions, isCanShowInstallInstructions, isCanPrompt]);

  useEffect(() => {
    SetIsShown(true);

    const handleCanPromptSuccess = () => {
      setIsCanPrompt(true);
    };
    if (global.window[WINDOW_KEY_INSTALL_EVENT]) {
      handleCanPromptSuccess();
    } else {
      window.addEventListener(CUSTOM_EVENT_TYPE_STASH_INSTALL_PROMPT, handleCanPromptSuccess);
    }

    return () => {
      window.removeEventListener(CUSTOM_EVENT_TYPE_STASH_INSTALL_PROMPT, handleCanPromptSuccess);
    };
  }, []);

  useEffect(() => {
    if (isPWAInstalled || isStandAlone || !isCanShowInstallInstructions) {
      setIsCanPrompt(false);
    }
  }, [isPWAInstalled, isStandAlone, isCanShowInstallInstructions]);

  if (!isCanPrompt) {
    return null;
  }

  return (
    <>
      <Button
        title={t("sw:installEGWWritings")}
        className={classNames(className, LANDING_SELECTORS.buttonInstallPWA.substring(1), {
          hidden: !isShown,
        })}
        onClick={handleClick}
        variant={variant ?? Button.variant.clear}
        color={color ?? Button.color.icon}
        size={size ?? Button.size.big}>
        {!isRenderAsText && <IconView icon={EgwWebFont.install} />}
        {isRenderAsText && t("sw:installEGWWritings")}
      </Button>
    </>
  );
};
ButtonInstallPWA.propTypes = {
  className: PropTypes.string,
  isRenderAsText: PropTypes.bool,
};

export default ButtonInstallPWA;
